import { render, staticRenderFns } from "./not-renewing-reason.vue?vue&type=template&id=263b641a&scoped=true&"
import script from "./not-renewing-reason.vue?vue&type=script&lang=js&"
export * from "./not-renewing-reason.vue?vue&type=script&lang=js&"
import style0 from "./not-renewing-reason.vue?vue&type=style&index=0&id=263b641a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263b641a",
  null
  
)

export default component.exports